import { render, staticRenderFns } from "./AvenantItemTree.vue?vue&type=template&id=0fe0d23a&scoped=true"
import script from "./AvenantItemTree.vue?vue&type=script&lang=ts"
export * from "./AvenantItemTree.vue?vue&type=script&lang=ts"
import style0 from "./AvenantItemTree.vue?vue&type=style&index=0&id=0fe0d23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0d23a",
  null
  
)

export default component.exports